import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6cf66c4c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6cf66c4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf66c4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cf66c4c')) {
      api.createRecord('6cf66c4c', component.options)
    } else {
      api.reload('6cf66c4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6cf66c4c&scoped=true&", function () {
      api.rerender('6cf66c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/Insurance/index.vue"
export default component.exports